import { createContext, ReactNode, useContext } from "react"
import type { Router } from "common/routing/router"

export const RouterProvider = (props: Props) => {
  return (
    <RouterContext.Provider value={props.router}>
      {props.children}
    </RouterContext.Provider>
  )
}

interface Props {
  router: Router
  children?: ReactNode
}

const RouterContext = createContext<Router | undefined>(undefined)

export const useRouter = () => {
  const context = useContext(RouterContext)

  if (!context) {
    throw new Error(
      "`useRouter` is meant be used in a component wrapped in a `Router`.",
    )
  }

  return context
}
